/** The road encounters (ADR 0093): the peddler's window and the lines of a chest or a rescue. */
export const ENCOUNTERS: Readonly<Record<string, string>> = {
  // ui/peddler-panel.ts
  Colporteur: 'Peddler',
  'Un seul lot, vendu entier.': 'One lot only, sold whole.',
  'Lot de {count}': 'Lot of {count}',
  'Pièce unique': 'Single piece',
  'Déjà acheté': 'Already bought',

  // ui/encounter-text.ts
  'Trop tard : la rencontre a repris la route.': 'Too late: the encounter has moved on.',
  'Approche-toi encore un peu.': 'Come a little closer.',
  'Relève-toi d’abord.': 'Get up first.',
  'Tu lui as déjà acheté son lot.': 'You already bought his lot.',
  'Tu as déjà vidé ce coffre.': 'You already emptied this chest.',
  'Un souci est survenu, rien n’a été dépensé : réessaie.':
    'Something went wrong, nothing was spent: try again.',
  'Voyageuse sauvée : +{xp} XP.': 'Traveller saved: +{xp} XP.',
  'Voyageuse sauvée : +{xp} XP, et à tes pieds : {items}.':
    'Traveller saved: +{xp} XP, and at your feet: {items}.',
};
